import "./App.css";
import About from "./comonent/About/About";
import Contact from "./comonent/Contact/Contact";
import Footer from "./comonent/Footer/Footer";
import Home from "./comonent/Home/Home";
import BookingForm from "./comonent/Inquiry Form/BookingForm";
import Navbar from "./comonent/navBar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Products from "./comonent/Products/Products";
import SocialIcons from "./comonent/SocialIcons/SocialIcons";

import Explore from "./comonent/Explore/Explore";
import PrivacyPolicy from "./comonent/Footer/privacy-policy/privacy-policy";
import Terms_Conditions from "./comonent/Footer/privacy-policy/Terms_Conditions";
import Refund_Cancellations from "./comonent/Footer/privacy-policy/Refund_Cancellations";
import Shipping_Policy from "./comonent/Footer/privacy-policy/Shipping_Policy";
import PopupTestDrive from "./comonent/Home/PopupTestDrive/PopupTestDrive";
import { useTestDrive } from "./context/TestDriveContext";

const Page = ({ title }) => (
  <div style={{ padding: "40px" }}>
    <h1>{title}</h1>
    <p>This is the {title} page.</p>
  </div>
);

function App() {
  const { showPopup, closePopup } = useTestDrive();
  return (
    <Router>
      <Navbar />
      <SocialIcons />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/Shipping_policy" element={<Shipping_Policy />} />
        <Route path="/terms_conditions" element={<Terms_Conditions />} />
        <Route
          path="/Refund_Cancellations"
          element={<Refund_Cancellations />}
        />
        <Route path="*" element={<Page title="404 - Page Not Found" />} />
      </Routes>
      {showPopup && <PopupTestDrive onClose={closePopup} />}
      <BookingForm />
      <Footer />
    </Router>
  );
}

export default App;
